/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0",
    versionName: "absordofus 0.6.0",
    versionChannel: "absordofus",
    buildDate: "2026-09-24T00:21:56.766Z",
    commitHash: "cac5c99ce4a17e606f4ee3090389bb878f852055",
};
